import { memberProps } from '..';
import { console_log } from '../../config';

export type RoleTypes = null | 0 | 1 | 2 | 'admin' | 'employee';

export interface sessionProps {
    MemberGuid: string | null | undefined;
    SessionGuid: string | null | undefined;
    Role: RoleTypes;
    ForceChangePassword: 1 | 0;
    Type: RoleTypes;
}

export interface authReducerProps {
    session: sessionProps;
    userInfo: memberProps | null;
}

export type authReducerActionTypes =
    | { type: 'RESET' }
    | { type: 'RESET_SESSION' }
    | { type: 'SET_SESSION'; session: sessionProps }
    | { type: 'UPDATE_ROLE'; Role: RoleTypes }
    | { type: 'UPDATE_FORCE_CHANGE_PASSWORD'; state: any }
    | { type: 'SET_USER_INFO'; userInfo: memberProps };

export const sessionInitialState: sessionProps = {
    MemberGuid: null,
    SessionGuid: null,
    Role: null,
    ForceChangePassword: 1,
    Type: null
};

export const authReducerInitialState: authReducerProps = {
    session: sessionInitialState,
    userInfo: null
};

export const authReducerInit = (initialState: authReducerProps) => {
    return {
        session: {
            MemberGuid: localStorage.getItem('MemberGuid')
                ? localStorage.getItem('MemberGuid')
                : initialState.session.MemberGuid,
            SessionGuid: localStorage.getItem('SessionGuid')
                ? localStorage.getItem('SessionGuid')
                : initialState.session.SessionGuid,
            Role: initialState.session.Role,
            Type: initialState.session.Type,
            ForceChangePassword:
                localStorage.getItem('ForceChangePassword') === '0'
                    ? 0
                    : initialState.session.ForceChangePassword
        },

        userInfo: initialState.userInfo
    };
};

export const authReducer = (
    state: authReducerProps,
    action: authReducerActionTypes
) => {
    console_log(action.type, '\n', action);
    console_log('====================================');
    switch (action.type) {
        case 'RESET':
            return authReducerInit(authReducerInitialState);
        case 'RESET_SESSION':
            localStorage.removeItem('MemberGuid');
            localStorage.removeItem('SessionGuid');
            return { ...state, session: sessionInitialState };
        case 'SET_SESSION':
            action.session.MemberGuid &&
                localStorage.setItem('MemberGuid', action.session.MemberGuid);
            action.session.SessionGuid &&
                localStorage.setItem('SessionGuid', action.session.SessionGuid);
            action.session.ForceChangePassword === 0 &&
                localStorage.setItem(
                    'ForceChangePassword',
                    JSON.stringify(action.session.ForceChangePassword)
                );
            return {
                ...state,
                session: action.session,
                ForceChangePassword: action.session.ForceChangePassword === 0 ? 0 : 1
            };
        case 'UPDATE_ROLE':
            return {
                ...state,
                session: { ...state.session, Role: action.Role }
            };
        case 'UPDATE_FORCE_CHANGE_PASSWORD':
            localStorage.setItem('ForceChangePassword', action.state);
            return {
                ...state,
                session: { ...state.session, ForceChangePassword: action.state }
            };
        case 'SET_USER_INFO':
            return {
                ...state,
                userInfo: action.userInfo
            };
        default:
            return state;
    }
};
